// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as React from "react";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as HtmlEntities from "../../utils/HtmlEntities.bs.jsx";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as DialogCycling from "../../components/DialogCycling/DialogCycling.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FormattedVolume from "../../components/FormattedVolume/FormattedVolume.bs.jsx";
import * as FormattedPercent from "../../components/FormattedPercent/FormattedPercent.bs.jsx";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as FormattedDateTime from "../../components/FormattedDataTime/FormattedDateTime.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as DialogConfirmation from "../../components/DialogConfirmation/DialogConfirmation.bs.jsx";
import KegDetailModuleCss from "./KegDetail.module.css";
import * as FormattedDateTimeShort from "../../components/FormattedDataTime/FormattedDateTimeShort.bs.jsx";
import TableConsumptionsModuleCss from "../../components/TableConsumptions/TableConsumptions.module.css";

let classes = KegDetailModuleCss;

let tableConsumptionsClasses = TableConsumptionsModuleCss;

function KegDetail(props) {
  let onFinalizeKeg = props.onFinalizeKeg;
  let onDismiss = props.onDismiss;
  let onDeleteKeg = props.onDeleteKeg;
  let onDeleteConsumption = props.onDeleteConsumption;
  let personsAllById = props.personsAllById;
  let keg = props.keg;
  let formatConsumption = props.formatConsumption;
  let consumptionsByTimestampDesc = React.useMemo(() => {
    let consumptionEntries = Object.entries(keg.consumptions);
    consumptionEntries.sort((a, b) => b[0].localeCompare(a[0]));
    return consumptionEntries;
  }, [keg.consumptions]);
  let firstConsumption = Db.kegFirstConsumptionTimestamp(keg);
  let priceLargeBeer = keg.price / keg.milliliters * 500.0 | 0;
  let effectivity = keg.consumptionsSum / keg.milliliters;
  let kegId = Db.getUid(keg);
  let kegName = keg.serialFormatted + ` ` + keg.beer;
  let maybeTapName = Stdlib_Option.map(Object.entries(props.place.taps).find(param => Stdlib_Option.getOr(Stdlib_Option.map(Primitive_option.fromNull(param[1]), kegRef => kegRef.id === kegId), false)), param => param[0]);
  let match = React.useState(() => "Hidden");
  let setDialog = match[1];
  let depletedAt = keg.depletedAt;
  let tmp;
  switch (match[0]) {
    case "Hidden" :
      tmp = null;
      break;
    case "ConfirmDelete" :
      tmp = <DialogConfirmation.make
        className={DialogConfirmation.classes.deleteConfirmation}
        heading={"Odstranit sud ?"}
        onConfirm={() => {
          onDismiss();
          onDeleteKeg();
        }}
        onDismiss={() => setDialog(param => "Hidden")}
        visible={true}
      >
        <p>
          {`Chystáte se odstranit sud `}
          <b>
            {kegName}
          </b>
          {` z aplikace. Chcete pokračovat?`}
        </p>
      </DialogConfirmation.make>;
      break;
    case "ConfirmFinalize" :
      tmp = <DialogConfirmation.make
        className={DialogConfirmation.classes.deleteConfirmation + ` ` + classes.dialogCloseKeg}
        heading={"Chystáte se rozúčtovat sud"}
        onConfirm={() => {
          onDismiss();
          onFinalizeKeg();
        }}
        onDismiss={() => setDialog(param => "Hidden")}
        visible={true}
      >
        <dl
          className={Styles.descriptionList.hyphen}
        >
          <dt>
            {"Název sudu"}
          </dt>
          <dd>
            {kegName}
          </dd>
          <dt>
            {"Celkem vytočeno"}
          </dt>
          <dd>
            <FormattedVolume.make
              milliliters={keg.consumptionsSum}
            />
            {" z "}
            <FormattedVolume.make
              milliliters={keg.milliliters}
            />
            {" (efektivita "}
            <FormattedPercent.make
              value={effectivity * 100.0}
            />
            {")"}
          </dd>
          <dt>
            {`Výsledná cena velkého piva` + HtmlEntities.nbsp + `*`}
          </dt>
          <dd>
            <FormattedCurrency.make
              value={priceLargeBeer / effectivity | 0}
            />
          </dd>
        </dl>
        <p>
          {`* Mezi konzumenty se rozpočítává cena sudu, výslednou cenu velkého piva tak ovlivňuje
          efektivita výtoče.`}
        </p>
        {effectivity > 0.7 ? <p
            className={Styles.messageBar.base}
            role={"alert"}
          >
            {`Rozúčtování je nevratná operace. Ujistěte se, že máte správny sud.`}
          </p> : <p
            className={Styles.messageBar.variantDanger}
            role={"alert"}
          >
            <b>
              {`Efektivita výtoče je velmi nízká.`}
            </b>
            {` Rozúčtování je nevratná operace. Ujistěte se, že máte správny sud.`}
          </p>}
      </DialogConfirmation.make>;
      break;
  }
  return <>
    <DialogCycling.make
      className={classes.root}
      hasNext={props.hasNext}
      hasPrevious={props.hasPrevious}
      header={kegName}
      onDismiss={onDismiss}
      onNext={props.onNextKeg}
      onPrevious={props.onPreviousKeg}
      visible={true}
    >
      <dl
        className={Styles.descriptionList.inline}
      >
        <div>
          <dt>
            {"objem"}
          </dt>
          <dd>
            <FormattedVolume.make
              milliliters={keg.milliliters}
            />
          </dd>
        </div>
        {keg.depletedAt !== null || keg.consumptionsSum === 0 ? null : <div>
            <dt>
              {"zbýbá"}
            </dt>
            <dd>
              <FormattedVolume.make
                milliliters={keg.milliliters - keg.consumptionsSum | 0}
              />
            </dd>
          </div>}
        <div>
          <dt>
            {"naskladněno dne"}
          </dt>
          <dd>
            <FormattedDateTime.make
              value={keg.createdAt.toDate()}
            />
          </dd>
        </div>
        <div>
          <dt>
            {"za"}
          </dt>
          <dd>
            <FormattedCurrency.make
              value={keg.price}
            />
          </dd>
        </div>
        <div>
          <dt>
            {"t.j. velké pivo za"}
          </dt>
          <dd>
            <FormattedCurrency.make
              value={priceLargeBeer}
            />
          </dd>
        </div>
        {firstConsumption !== undefined ? <div>
            <dt>
              {"první výtoč"}
            </dt>
            <dd>
              <FormattedDateTime.make
                value={new Date(firstConsumption)}
              />
            </dd>
          </div> : null}
        {depletedAt !== null ? <>
            <div>
              <dt>
                {"dopito"}
              </dt>
              <dd>
                <FormattedDateTime.make
                  value={depletedAt.toDate()}
                />
              </dd>
            </div>
            <div>
              <dt>
                {"ze sudu se vytočilo"}
              </dt>
              <dd>
                <FormattedVolume.make
                  milliliters={keg.consumptionsSum}
                />
              </dd>
            </div>
            <div>
              <dt>
                {"efektivita"}
              </dt>
              <dd>
                <FormattedPercent.make
                  value={effectivity * 100.0}
                />
              </dd>
            </div>
            <div>
              <dt>
                {"výsledná cena za velké pivo"}
              </dt>
              <dd>
                <FormattedCurrency.make
                  value={priceLargeBeer / effectivity | 0}
                />
              </dd>
            </div>
          </> : null}
      </dl>
      {maybeTapName !== undefined ? <p
          className={Styles.messageBar.base}
        >
          {`Sud je naražen na pípu `}
          <b>
            {maybeTapName}
          </b>
        </p> : null}
      {keg.depletedAt !== null || !props.isUserAuthorized(80) || consumptionsByTimestampDesc.length === 0 ? null : <div
          className={classes.actions}
        >
          <button
            className={Styles.button.variantDanger}
            disabled={consumptionsByTimestampDesc.length === 0}
            type={"button"}
            onClick={param => setDialog(param => "ConfirmFinalize")}
          >
            {"Odepsat ze skladu a rozúčtovat"}
          </button>
        </div>}
      {consumptionsByTimestampDesc.length !== 0 ? <table
          className={Styles.table.inDialog + ` ` + tableConsumptionsClasses.table}
        >
          <caption>
            {"Vytočená piva"}
          </caption>
          <thead>
            <tr>
              <th
                scope={"col"}
              >
                {"Jméno"}
              </th>
              <th
                scope={"col"}
              >
                {"Kdy"}
              </th>
              <th
                scope={"col"}
              >
                {"Objem"}
              </th>
              <th
                scope={"col"}
              >
                <span
                  className={Styles.utility.srOnly}
                >
                  {"Akce"}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {consumptionsByTimestampDesc.map(param => {
              let consumption = param[1];
              let timestampStr = param[0];
              let person = personsAllById[consumption.person.id];
              let createdData = new Date(Stdlib_Option.getOrThrow(Stdlib_Float.fromString(timestampStr), undefined));
              return <tr
                key={timestampStr} >
                <th
                  scope={"row"}
                >
                  {person.name}
                </th>
                <td>
                  <FormattedDateTimeShort.make
                    value={createdData}
                  />
                </td>
                <td>
                  {formatConsumption(consumption.milliliters)}
                </td>
                <td>
                  {keg.depletedAt !== null ? null : <button
                      className={Styles.button.sizeExtraSmall + ` ` + tableConsumptionsClasses.deleteButton}
                      type={"button"}
                      onClick={param => onDeleteConsumption(timestampStr)}
                    >
                      {"🗑️ Smáznout"}
                    </button>}
                </td>
              </tr>;
            })}
          </tbody>
        </table> : <p>
          {"Ze sudu zatím neevidujeme čepování."}
          {(
            maybeTapName !== undefined ? null : <>
                {" Pokud jste sud přidali omylem můžete ho "}
                <button
                  className={Styles.link.base}
                  type={"button"}
                  onClick={param => setDialog(param => "ConfirmDelete")}
                >
                  {"odebrat z aplikace"}
                </button>
                {"."}
              </>
          )}
        </p>}
    </DialogCycling.make>
    {tmp}
  </>;
}

let make = KegDetail;

export {
  classes,
  tableConsumptionsClasses,
  make,
}
/* classes Not a pure module */
